module.exports = __webpack_public_path__ + "static/eurasia-40dd71e331721dcc848c88fefc1593ba.png";